import { Dialog, DialogContent, DialogActions, Button } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import styled from '@emotion/styled'

const OcrReprocessConfirmModal = ({
  open,
  onClose,
  onConfirm,
  cardLabel,
  title = 'OCR Completed',
  message,
  subMessage = 'Confirm you want to re-run OCR',
  confirmText = 'Re-run OCR',
  loading = false
}) => {
  const resolvedMessage =
    message ??
    (cardLabel
      ? `${cardLabel} has already been validated.`
      : 'This card has already been validated.')

  const handleClose = () => {
    if (loading) return
    onClose?.()
  }

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <Header>
        <StatusPill>
          <PillText>OCR</PillText>
          <CheckWrap>
            <CheckIcon fontSize="small" sx={{ fontSize: '15px' }} />
          </CheckWrap>
        </StatusPill>
        <Title>{title}</Title>
      </Header>

      <StyledContent>
        <Message>{resolvedMessage}</Message>
        <SubMessage>{subMessage}</SubMessage>
      </StyledContent>

      <StyledActions>
        <SecondaryButton onClick={handleClose} disabled={loading}>
          Cancel
        </SecondaryButton>
        <PrimaryButton onClick={onConfirm} disabled={loading}>
          {loading ? 'Processing...' : confirmText}
        </PrimaryButton>
      </StyledActions>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 12px;
    max-width: 400px;
    width: 100%;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 24px 8px;
`

const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 10px;
  gap: 3px;
  border-radius: 999px;
  background: #2dbb38;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
`

const PillText = styled.span`
  font-size: 12px;
  font-weight: 800;
`

const CheckWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Title = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme?.colors?.black || '#000'};
`

const StyledContent = styled(DialogContent)`
  padding: 8px 24px 4px;
`

const Message = styled.p`
  margin: 0 0 8px;
  font-size: 0.95rem;
  color: #333;
`

const SubMessage = styled.p`
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.4;
  color: #666;
`

const StyledActions = styled(DialogActions)`
  padding: 12px 24px 20px;
  gap: 10px;
`

const SecondaryButton = styled(Button)`
  text-transform: none;
  font-weight: 600;
  padding: 6px 16px;
  color: #555;
  border: 1px solid ${({ theme }) => theme?.colors?.gray || '#d3d3d3'};

  &:hover {
    background: ${({ theme }) => theme?.colors?.whisper || '#f5f7fb'};
    border-color: #bbb;
  }
`

const PrimaryButton = styled(Button)`
  text-transform: none;
  font-weight: 600;
  padding: 6px 16px;
  color: #fff;
  background: ${({ theme }) => theme?.colors?.yellow || '#ffc107'};
  box-shadow: none;

  &:hover {
    background: #e6ac06;
    box-shadow: none;
  }
`

export default OcrReprocessConfirmModal
